export {
    ADG4CustomerTestimonials,
    type PatternADG4TestimonialProps,
    type TestimonialsTypes
} from "./customer-testimonials";
export { ADG4CustomerTestimonials as default } from "./customer-testimonials";
